export default __webpack_public_path__ + "static/media/getwotty_bank.4ed871ce.png";